import React from "react";

function Footer() {
  return (
    <footer className="mi-footer">
      <div className="mi-footer-inner">
        <p>© {new Date().getFullYear()} Kaylei Burke</p>
      </div>
    </footer>
  );
}

export default Footer;
